import { unwrap } from "@sagot/api-client";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import { wsKeys } from "./query-keys";

/** `GET /v1/agents` (header copy, playground link, share dialog). */
export function useAgentList() {
  const api = useApi();
  const wsId = useWorkspaceId();
  return useQuery({ queryKey: wsKeys.agents(wsId), queryFn: async () => (await unwrap(api.GET("/v1/agents"))).items, staleTime: 60_000 });
}
